import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
@NgModule({
  imports: [CommonModule, MatDialogModule],
  declarations: [AlertDialogComponent, ConfirmDialogComponent],
  providers: [],
  exports: [MatDialogModule, AlertDialogComponent, ConfirmDialogComponent],
})
export class DialogsModule {}
